/**********************************************************
Fertilizer View
**********************************************************/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchFertilizerApplications, selectFertilizerApplication,
  deleteFertilizerApplication } from '../../actions/fertilizer_actions';
import FabModalV2 from '../fab_modal_v2';
import FertilizerApplicationDisplay from './fert_app_display';
import { fetchEmployees } from '../../actions/utils_actions';
import moment from 'moment';

class FertilizerView extends Component {
  componentDidMount() {
    this.props.fetchFertilizerApplications();
    if (this.props.employees.length === 0) this.props.fetchEmployees();
  }
  render() {
    return (
      <div className="row">
        <div className="chem-app-table-view">
          <table className="bordered highlight responsive-table centered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Field</th>
                <th>Employee</th>
                <th>Hours</th>
                <th>Acres Completed</th>
                <th>Acres Balance</th>
                <th>Status</th>
                <th>Product</th>
                <th>Quantity</th>
                <th>Round</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {
                this.props.fertilizerApplications.map((f) => {
                  let { fertilizerApplied } = f;
                  let name = 'N/A';
                  let emp = {};
                  if (this.props.employees.length > 0 && f.employee !== undefined) {
                    emp = this.props.employees.find((e) => e.eid === f.employee);
                    if (emp) name = `${ emp.firstName[0] }. ${ emp.lastName }`;
                  }

                  return fertilizerApplied.map((fert) => {
                    let c = this.props.chemicalList.find((cl) => cl.id === Number(fert.chemId));
                    if (c === undefined) c = {};

                    return (
                      <tr key={fert.id}>
                        <td>{ moment(f.date).format('MM/DD/YYYY') }</td>
                        <td>{ fert.field }</td>
                        <td>{ name }</td>
                        <td>{ fert.hours }</td>
                        <td>{ fert.acresCompleted }</td>
                        <td>{ fert.acresBalance }</td>
                        <td>
                          { f.isComplete === 0 || f.isComplete === '0' ? <span className="label label-incomplete">Incomplete</span>
                           : <span className="label label-complete">Complete</span>
                          }
                        </td>
                        <td>
                          <span className="chem-app-table-name"><b>{ c.name }</b>: {c.ingredients}</span>
                          <span className="icon-shift"><i className={'material-icons'}>{ fert.unitOfMeasure === 'tons' ? 'grain' : 'invert_colors' }</i></span>
                        </td>
                        <td>{ fert.quantityApplied } { fert.unitOfMeasure }</td>
                        <td>{ f.round }</td>
                        <td>
                            <div>
                              <ul className="btn-actions">
                                {
                                  FabModalV2(FertilizerApplicationDisplay)
                                  // eslint-disable-next-line
                                  ({
                                    id: `${f.id}-view`,
                                    auth: false,
                                    user: this.props.user,
                                    employees: this.props.employees,
                                    chemicalList: this.props.chemicalList,
                                    previousApplications: [],
                                    toDelete: false,
                                    view: true,
                                    footer: true,
                                    application: f,
                                    _select: () => this.props.selectFertilizerApplication(f)
                                  })
                                }
                                { Object.keys(this.props.user).length === 0 ? ''
                                  : this.props.user.level >= 3 || this.props.user.positionTitle.match(/Cultivation/) ?

                                  FabModalV2(FertilizerApplicationDisplay)
                                  // eslint-disable-next-line
                                  ({
                                    id: `${f.id}-delete`,
                                    auth: true,
                                    user: this.props.user,
                                    employees: this.props.employees,
                                    chemicalList: this.props.chemicalList,
                                    previousApplications: [],
                                    toDelete: true,
                                    view: false,
                                    footer: true,
                                    application: f,
                                    _select: () => this.props.selectFertilizerApplication(f),
                                    onClick: () => this.props.deleteFertilizerApplication({ fertAppId: this.props.selectedApp.fertAppId })
                                  })
                                  : ''
                                }
                              </ul>
                            </div>
                          </td>

                      </tr>
                    )
                  })
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    chemicalList: state.cultivation.chemical.chemicalList,
    employees: state.cultivation.utils.employees,
    fertilizerApplications: state.cultivation.fertilizer.fertilizerApplications.displaying,
    previousApplications: state.cultivation.fertilizer.app.previousApplications,
    selectedApp: state.cultivation.fertilizer.view.app,
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    deleteFertilizerApplication,
    fetchFertilizerApplications,
    fetchEmployees,
    selectFertilizerApplication
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(FertilizerView);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/fertilizer/fertilizer_view.js